<template lang="pug">
  v-container
    v-form(
      v-model="form"
      @submit.prevent="onClick"
      :disabled="!dataState.isReady")
      button.d-none(type="submit")
      v-row
        v-col
          v-text-field(
            v-model="dataState.data.name"
            filled
            :rules="[v => !!v || `Le nom est requis.`]"
            label="Nom")
      v-row
        v-col
          input-image(
            v-model="dataState.data.image"
            :rules="[v => !!v || `L'image est requise.`]"
            :image-width="200"
            :image-height="200"
            label="Image")
      v-row
        v-col
          input-color.mx-auto(
            v-model="dataState.data.color"
            hide-canvas
            :rules="[v => !!v || `La couleur est requise.`]"
            label="Couleur")
</template>

<script>
import InputImage from '@iez/components/inputs/image/'
import InputColor from '@iez/components/inputs/color/'
import { reactive, toRefs, computed } from '@vue/composition-api'
import { page } from '@iez/core'
import data from '@iez/lib/data/'
import router, { routeCurrent } from '@iez/core/router/'
import fromDataState from '@iez/lib/from-data-state/'

const route = {
  name: `ManageThemesAdd`,
  path: `/manage-themes-add/:id?`
}

export default {
  ...route,

  components: {
    InputImage,
    InputColor
  },

  setup () {
    const id = routeCurrent.params.id
    const isEditing = !!id
    const fields = [
      `id`,
      `name`,
      `color`, {
        image: [
          `id`,
          `src`,
          `srcLazy`
        ]
      }
    ]

    const theme = isEditing
      ? data.get({
          root: `themes`,
          one: true,
          request: {
            where: {
              id: {
                _eq: id
              }
            }
          },
          fields
        }) : null

    const state = reactive({
      form: false,
      dataState: fromDataState({
        getId: () => theme.value?.id,
        props: {
          name: {
            get: () => theme.value.name
          },
          color: {
            get: () => theme.value.color
          },
          image: {
            type: `image`,
            get: () => theme.value.image
          }
        }
      })
    })

    page.topBar.set({
      title: computed(
        () => isEditing
          ? `Modification d'un thème`
          : `Ajout d'un thème`
      )
    })

    const onClick = async () => {
      const smartPatch = await state.dataState.smartPatch()
      if (isEditing) {
        await data.update({
          root: `themes`,
          id,
          _set: smartPatch,
          fields
        })
      } else {
        await data.set({
          root: `themes`,
          items: [smartPatch],
          fields
        })
      }
      page.bottomSnackbar.set({
        content: computed(
          () => isEditing
            ? `Thème modifié`
            : `Thème ajouté`
        ),
        afterEnter: true
      })
      router.back()
    }

    page.bottomAction.set(
      () => state.form && state.dataState.patch
        ? {
          action: {
            label: computed(
              () => isEditing
                ? `Modifier`
                : `Ajouter`
            ),
            onClick
          }
        } : null
    )

    return {
      ...toRefs(state),
      onClick
    }
  }
}
</script>
